import {OperationGroup, PartnerMerchant} from '../shared/model/operations/partners/PartnerMerchant';

export const onlyPartnersWithEnabledOperation = (group: OperationGroup): (partner: PartnerMerchant) => boolean => {
  return partner => {
    const partnerOperationConfig = partner.operations.find(operation => operation.operationGroup === group);
    return partner.enabled && !!partnerOperationConfig && partnerOperationConfig.enabled;
  }
};
